import { getSelectionChangeEffect } from '@openeducation/hr-js-utils';
import { HRPageTemplate, HRPageTemplateProps } from '@openeducation/hr-rn-components';
import { omLanguageSelected } from '@openeducation/hr-rn-jotai-atoms';
import { usePurchaserId, usePurchaserScope } from '@openeducation/hr-rn-providers';
import { OrganizationType } from '@openeducation/hr-rn-shared-types';
import { useSetAtom } from 'jotai';
import React from 'react';

import { OEPath, Path, OMPath, getHomePathByPath } from './paths';
import { useLocation, useNavigate } from './router';

const PageTemplate = ({
  children,
  ...props
}: Omit<HRPageTemplateProps, 'onSwitchPortal'> & {
  children: React.ReactNode;
}) => {
  const setLanguage = useSetAtom(omLanguageSelected);
  const location = useLocation();
  const navigate = useNavigate();
  const currentPath = location.pathname;
  const pagePurchaserId = usePurchaserId();
  const { kind, primaryPurchaserId, scopedPurchaserId } = usePurchaserScope();

  const onSwitchPortal = (organization: OrganizationType) => {
    setLanguage(null);

    switch (organization) {
      case OrganizationType.OPEN_MUNDO:
        navigate(OMPath.Home);
        break;
      case OrganizationType.OPEN_ENGLISH:
      default:
        navigate(OEPath.Home);
        break;
    }
  };

  const onPurchaserSwitched = (selectedIds: string[]) => {
    const homePath = getHomePathByPath(currentPath);
    const { leavePage, resetLanguage } = getSelectionChangeEffect({
      selectedIds,
      primaryPurchaserId,
      pagePurchaserId,
      scopedPurchaserId,
      kind,
    });
    if (resetLanguage) {
      setLanguage(null);
    }
    if (leavePage && homePath) {
      navigate(homePath);
    }
  };

  if ([Path.Choice, Path.ExternalPortal].includes(currentPath as Path)) {
    return <>{children}</>;
  }
  return (
    <HRPageTemplate
      {...props}
      onSwitchPortal={onSwitchPortal}
      onPurchaserSwitched={onPurchaserSwitched}
    >
      {children}
    </HRPageTemplate>
  );
};

export { PageTemplate };
